import {
    USER_DETAIL_REQUESTED,
    USER_DETAIL_RECEIVED,
    USER_DETAIL_ERROR
} from '../actions/userDetail.js';
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
 * @return {RequestResult}
 */
export const userDetail = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case USER_DETAIL_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), state.data);
        case USER_DETAIL_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.userDetail, action.receivedAt);
        case USER_DETAIL_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
        default:
            return state
    }
};
